import { styled } from '@linaria/react';
import { inkDarkest, inkLight, skyLight, skyLightest } from '../../../styles/design-tokens';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  position: relative;
`;

const Body = styled.div`
  padding: 4px 0 16px;
  display: flex;
  flex-direction: column;
`;

const SectionLabel = styled.div`
  font: 600 10px/1 'Figtree', sans-serif;
  color: ${inkLight};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
`;

const Prompt = styled.div`
  max-height: 160px;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  padding: 8px 10px;
  font: 400 12px/1.4 'Figtree', sans-serif;
  color: ${inkDarkest};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: ${skyLightest};
  border: 1px solid ${skyLight};
  border-radius: 8px;
`;

const MetaLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const MetaValue = styled.span`
  max-width: 65%;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export { Body, MetaLabel, MetaValue, Prompt, SectionLabel, Wrapper };
